/**
 * @generated SignedSource<<d6a5c055f88997f00daff8d183cb1505>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedRelatedSellerTitle_seller$data = {
  readonly sellerProfile: {
    readonly company: string | null;
  } | null;
  readonly shippingAddress: {
    readonly displayCityStateCountry: string | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"SharedStarRating_seller" | "sellerBrandingHelpers_seller">;
  readonly " $fragmentType": "SbSharedRelatedSellerTitle_seller";
};
export type SbSharedRelatedSellerTitle_seller$key = {
  readonly " $data"?: SbSharedRelatedSellerTitle_seller$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedRelatedSellerTitle_seller">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedRelatedSellerTitle_seller",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedStarRating_seller"
    },
    {
      "kind": "InlineDataFragmentSpread",
      "name": "sellerBrandingHelpers_seller",
      "selections": [
        {
          "alias": "isRewarded",
          "args": [
            {
              "kind": "Literal",
              "name": "listNames",
              "value": [
                "SELLER_REWARDS_1",
                "SELLER_REWARDS_2"
              ]
            }
          ],
          "kind": "ScalarField",
          "name": "isAnchorListsMember",
          "storageKey": "isAnchorListsMember(listNames:[\"SELLER_REWARDS_1\",\"SELLER_REWARDS_2\"])"
        }
      ],
      "args": null,
      "argumentDefinitions": []
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SellerProfile",
      "kind": "LinkedField",
      "name": "sellerProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "company",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Address",
      "kind": "LinkedField",
      "name": "shippingAddress",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayCityStateCountry",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Seller",
  "abstractKey": null
};

(node as any).hash = "fe869067f09467f8275d861a5d3d332f";

export default node;
